// extracted by mini-css-extract-plugin
export default {"box":"retailerListPage_box__eqnPy"};